import clsx from "clsx";

import { CommunityMemberAvatar } from "@/client_app/components/CommunityMemberAvatar";
import { isFinishingSoon } from "@/client_app/features/weployees/utils/operations";
import { Checkbox } from "@/ui/Checkbox";

interface CommunityMember {
  fullName: string;
  mobileNumber?: string;
  profileImageUrl?: string;
}
interface Onboarding {
  completed: number;
  total: number;
}
interface ItemWithDate {
  description: string;
  date: string;
}

interface Absences {
  thisWeek: string;
  lastWeek: string;
}

interface Performance {
  value: string;
  type: string;
}

interface ActivePositionsListItemDesktopProps {
  communityMember: CommunityMember;
  finishOn: string;
  startOn: string;
  onboarding: Onboarding;
  feedback: ItemWithDate;
  coaching: ItemWithDate;
  absences: Absences;
  performance: Performance;
  title: string | JSX.Element;
  checked: boolean;
  newJobAcceptance: boolean;
  onChange: () => void;
  onClick: () => void;
  positionId: string;
  inAdmin?: boolean;
}

const ActivePositionsListItemDesktop = ({
  communityMember,
  finishOn,
  startOn,
  title,
  checked,
  onboarding,
  feedback,
  coaching,
  absences,
  performance,
  newJobAcceptance,
  onChange,
  onClick,
  inAdmin,
  positionId,
}: ActivePositionsListItemDesktopProps): JSX.Element => {
  const { fullName, mobileNumber, profileImageUrl } = communityMember;

  const tableCellStyleClasses =
    "border border-neutral-200 border-l-0 border-r-0 first:border-l last:border-r first:rounded-tl-xl first:rounded-bl-xl last:rounded-br-xl last:rounded-tr-xl py-4 px-5 first:pl-6 last:pr-6";

  return (
    <tr>
      <td className={clsx(tableCellStyleClasses)}>
        <div className='flex items-center gap-x-4'>
          {!inAdmin && <Checkbox checked={checked} onChange={onChange} />}
          <CommunityMemberAvatar
            profileImageUrl={profileImageUrl}
            name={fullName}
            size='SMALL'
          />
          <div className='text-left'>
            <span
              onClick={onClick}
              className='hover:underline cursor-pointer active_position_cm_full_name'
            >
              {fullName}
            </span>
            <span className='text-sm text-gray-500 italic'>
              {" "}
              {mobileNumber}
            </span>
            <div className='text-sm truncate max-w-xs text-gray-500'>
              {title}
            </div>
          </div>
          {newJobAcceptance && (
            <div className='py-1 px-3 rounded-full bg-primary-50'>NEW</div>
          )}
          <div
            id={`position-${positionId.substring(0, 10)}`}
            className='text-red-500 hidden pending-error'
          ></div>
        </div>
      </td>
      <td className={clsx(tableCellStyleClasses)}>{startOn}</td>
      <td
        className={clsx(
          tableCellStyleClasses,
          isFinishingSoon(finishOn) ? "text-error-600" : ""
        )}
      >
        {finishOn}
      </td>
      <td className={clsx(tableCellStyleClasses)}>
        <div>
          {onboarding.total === 0 ? null : onboarding.completed ===
            onboarding.total ? (
            "Done"
          ) : (
            <span className={onboarding.completed === 0 ? "text-red-500" : ""}>
              {onboarding.completed} / {onboarding.total}
            </span>
          )}
        </div>
      </td>
      <td className={clsx(tableCellStyleClasses)}>
        <div>{coaching.description}</div>
        <div>{coaching.date}</div>
      </td>
      <td className={clsx(tableCellStyleClasses)}>
        <div>{feedback.description}</div>
        <div>{feedback.date}</div>
      </td>
      <td className={clsx(tableCellStyleClasses)}>
        <div>{absences.lastWeek} last week</div>
        <div>{absences.thisWeek} this week</div>
      </td>
      <td className={clsx(tableCellStyleClasses)}>
        <div>
          {performance?.type === "percentage"
            ? `${performance.value}%`
            : performance
            ? performance.value
            : ""}
        </div>
      </td>
      <td className={clsx(tableCellStyleClasses)}></td>
    </tr>
  );
};

export { ActivePositionsListItemDesktop };
